import { useEffect, useState } from "react";
import { api } from "./api";

// Paramètres boutique partagés (chargés une fois) — visibilité des pages/sections, etc.
let cache = null;
let promise = null;

export function useShopSettings() {
  const [settings, setSettings] = useState(cache || null);
  useEffect(() => {
    if (cache) { setSettings(cache); return; }
    if (!promise) {
      promise = api.get("/settings/shop")
        .then((r) => (cache = r.data || {}))
        .catch(() => (cache = {}));
    }
    promise.then(setSettings);
  }, []);
  return settings || {};
}

// Une section est masquée si sa clé est dans disabled_sections
export const isSectionOff = (settings, key) =>
  (settings?.disabled_sections || []).includes(key);

// Sections activables/désactivables dans l'admin (Paramètres → Pages et sections)
export const SECTION_DEFS = [
  { key: "boutique", label: "La Boutique (page boutique et visionneuse)", group: "Pages" },
  { key: "forfaits", label: "Forfaits Tournoi", group: "Pages" },
  { key: "catalogues", label: "Les Catalogues", group: "Pages" },
  { key: "plaquettes", label: "Plaquettes sur mesure", group: "Pages" },
  { key: "blogue", label: "Blogue", group: "Pages" },
  { key: "realisations", label: "Réalisations", group: "Pages" },
  { key: "a-propos", label: "À propos", group: "Pages" },
  { key: "faq", label: "FAQ", group: "Pages" },
  { key: "contact", label: "Contact", group: "Pages" },
  { key: "soumission", label: "Soumission en 30 secondes (page /soumission-rapide)", group: "Pages" },
  { key: "parrainage", label: "Parrainage", group: "Pages" },
  { key: "badge", label: "Badge partenaire", group: "Pages" },
  { key: "guide-vendeur", label: "Guide du vendeur", group: "Pages" },
  { key: "home_chapters", label: "Accueil — Savoir-faire (3 chapitres)", group: "Page d'accueil" },
  { key: "home_collection", label: "Accueil — La collection (produits vedettes)", group: "Page d'accueil" },
  { key: "home_craft", label: "Accueil — Personnalisation (appel à l'action)", group: "Page d'accueil" },
  { key: "home_testimonials", label: "Accueil — Témoignages", group: "Page d'accueil" },
  { key: "home_final", label: "Accueil — Appel à l'action final", group: "Page d'accueil" },
  { key: "bandeau_forfaits", label: "Accueil — Bandeau Forfaits Tournoi (saisonnier)", group: "Page d'accueil" },
];

// Correspondance chemin → clé de section (navigation, pied de page)
export const PATH_SECTION = {
  "/boutique": "boutique",
  "/catalogue": "boutique",
  "/forfaits": "forfaits",
  "/catalogues": "catalogues",
  "/plaquettes-sur-mesure": "plaquettes",
  "/blogue": "blogue",
  "/realisations": "realisations",
  "/a-propos": "a-propos",
  "/faq": "faq",
  "/contact": "contact",
  "/soumission-rapide": "soumission",
  "/parrainage": "parrainage",
  "/badge-partenaire": "badge",
  "/guide-vendeur": "guide-vendeur",
};
